<template>
    <div class="pages memberLevel">
        <div class="f1 ">
            <p class="t">
                <img src="../../assets/images/newIcon/margetmiddle_dvip_icon.png" alt="">
                <b>积木云会员</b>
                已启用<span>5</span> 个业务系统，停用<span>1</span>个业务系统
                <el-button type="text" @click="dialogVisible=true">启用/禁用</el-button>
            </p>
            <p class="ft">成为会员后，根据用户的行为划分等级。如淘宝会员根据淘气值划分</p>
            <div>
                <p>
                    <span class="lb">业务系统：</span>
                    <el-select v-model="value" placeholder="请选择业务系统">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </p>
                <p>
                    <el-button type="primary" round @click="dialogVisible2=true">招募会员</el-button>
                    <el-button @click="newLeve" round>新增会员等级</el-button>
                    <el-button round @click="dialogVisible3=true">规则设置</el-button>
                    <el-button round @click="goRecord">变更记录</el-button>
                </p>
            </div>
            <p class="zhuangt">
                <i class="el-icon-warning-outline"></i>
                当前会员等级正在陆续更新中，更新时间跟会员数量有关，可 <span>刷新</span> 查看最新状态
            </p>
        </div>
        <div class="f2">
            <el-table
                :data="tableData3"
                :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
                :cell-style="{textAlign:'center',fontSize:'12px'}"
                style="width: 100%;"
                >
                <el-table-column
                prop="name"
                label="会员等级"
                >
                    <template slot-scope="scope">
                        <div class="level">
                             {{scope.row.name}}
                            <span class="ye" :style="'background:'+scope.row.color"></span>
                        </div>
                        
                    </template>
                </el-table-column>
                <el-table-column
                prop="number"
               
                label="名称"
                >
                </el-table-column>
                <el-table-column
                prop="xmember"
                label="业务系统"
                cell-style="background:red;"
                >
                </el-table-column>
                <el-table-column
                prop="lmember"
                label="获得条件"
               >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="虚拟权益"
                >
                </el-table-column>
                <el-table-column
                prop="names"
                 show-overflow-tooltip
                label="优惠权益"
                >
                </el-table-column>
                <el-table-column
                prop="names2"
                label="会员数"
                >
                </el-table-column>
                <el-table-column
                prop="labellv"
                label="操作"
                width="160"
                >
                    <template slot-scope="scope">
                        <el-button type="text">编辑</el-button>
                        <el-button type="text">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page">
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            style="margin-top: 24px;"
            :current-page="query.page_index"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="query.page_size"
            layout="prev, pager, next, sizes, jumper"
            :total="total"
            ></el-pagination>
        </div>
        <el-dialog
        title="规则设置"
        :visible.sync="dialogVisible3"
        width="40%"
        :before-close="handleClose">
        <div class="dialogContent2">
            <div>
                <p class="title ">成长值设置</p>
                <p><i></i>消费获得<el-input v-model="input1" placeholder=""></el-input>成长值</p>
                <p><i></i>登录获得<el-input v-model="input2" placeholder=""></el-input>成长值</p>
                <p><i></i>注册获得<el-input v-model="input3" placeholder=""></el-input>成长值</p>
            </div>
            <div class="border"></div>
            <div>
                <p class="title ">积分设置</p>
                <p><i></i>登录获得<el-input v-model="input4" placeholder=""></el-input>积分</p>
                <p><i></i>消费<el-input v-model="input5" placeholder=""></el-input>元获得<el-input v-model="input6" placeholder=""></el-input>积分</p>
                <p><i></i>注册获得<el-input v-model="input7" placeholder=""></el-input>积分</p>
                <p><i></i>生日赠送<el-input v-model="input8" placeholder=""></el-input>积分</p>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible3 = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible3 = false">保 存</el-button>
        </span>
        </el-dialog>
        <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisible"
        width="40%"
        :before-close="handleClose">
        <div class="dialogContent">
            <div class="d1">
                <p>1.禁用客户等级后，客户仍能在个人中心看到会员等级入口，但是无法点击；</p>
                <p>2.客户仍能获得成长值，但是不会获得等级</p>
                <p>3.开启等级后，客户将立即按新的配置重算计算等级</p>
            </div>
            <el-table
            :data="tableData"
            :header-cell-style="{background:'#EEEEEE',textAlign: 'center',fontSize:'12px'}"
            :cell-style="{textAlign:'center',fontSize:'12px'}"
            style="width: 100%">
            <el-table-column
                prop="date"
                label="业务系统"
                >
            </el-table-column>
            <el-table-column
                prop="name"
                label="会员等级数量"
                >
            </el-table-column>
            <el-table-column
                prop="address"
                    label="关闭 ｜ 开启"
                >
                <template slot-scope="scope">
                    <div>
                        <el-switch
                            v-model="scope.row.address">
                        </el-switch>
                    </div>
                </template>
            </el-table-column>
            </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">保 存</el-button>
        </span>
        </el-dialog>
        <el-dialog
        :title="memberType==1 ? '选择业务系统' : '招募会员'"
        :visible.sync="dialogVisible2"
        :width="memberType==1 ? '30%' : '50%'"
        :before-close="handleClose">
        <div v-if="memberType==1" class="dialogContent" style="margin-top:20px;">
            <el-table
            :data="tableData"
            :header-cell-style="cellStyles"
            :cell-style="cellStyle"
            style="width: 100%">
            <el-table-column
                prop=""
                label=""
                width="60"
                >
                <template slot-scope="scope">
                    <span @click="chageS(scope.row)">
                       <el-radio v-model="checkVal" :label="scope.row.id"><span></span></el-radio>
                        <!-- <el-checkbox v-model="checkVal" :label="scope.row.id"></el-checkbox> -->
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                prop="date"
                label="业务系统"
                >
            </el-table-column>
            <el-table-column
                prop="name"
                label="会员数量"
                >
            </el-table-column>
            
            </el-table>
        </div>
        <div v-if="memberType==2" class="haibao">
            <div class="ewm">
                <img src="../../assets/images/newIcon/vip_bg1.png" alt="">
                <img class="e" src="../../assets/images/newIcon/ewm_bg.png" alt="">
            </div>
            
            <div class="shada">
                <p>分享链接</p> 
                <p>
                    <span>https://developer.orgwgaachttps://developer.orgwgaacf…</span>
                    <span>复制链接</span>
                </p>
                <p>
                    可推广至
                    <img src="../../assets/images/icons/weixin.png" alt="">
                    <img src="../../assets/images/icons/zhifubao.png" alt="">
                    <img src="../../assets/images/icons/qq.png" alt="">
                    <img src="../../assets/images/icons/weibo.png" alt="">
                    <img src="../../assets/images/icons/xinxi.png" alt="">
                    <img src="../../assets/images/icons/bilibili.png" alt="">
                    <img src="../../assets/images/icons/kuaishou.png" alt="">
                    <img src="../../assets/images/icons/zhihu.png" alt="">
                    等任意渠道
                </p>
                <p>
                    <el-button @click="dialogVisible2 = false" round>下载海报</el-button>
                    <el-button class="dow" type="primary" @click="memberType=2" round>下载二维码</el-button>
                </p>
            </div>
        </div>
        <span slot="footer" v-if="memberType==1" class="dialog-footer">
            <el-button @click="dialogVisible2 = false">取 消</el-button>
            <el-button type="primary" @click="memberType=2">下一步</el-button>
        </span>
        </el-dialog>
    </div>
</template>
<script>
const QUERY={
    keyword_search:"",
    page_index: 1,
    page_size: 10,
}
export default {
    data() {
        return {
            dialogVisible: false,
            dialogVisible2:false,
            dialogVisible3:false,
            query:JSON.parse(JSON.stringify(QUERY)),
            tableData3: [{
                name: 'VIP1',
                number:"注册会员",
                xmember:"颐安中台",
                lmember:"0成长值",
                labellv:"虚拟权益名称",
                names:"国庆特惠券等3张国庆特惠券等3张券…",
                names2:"100",
                color:"#FEBD5F"
                },{
                name: 'VIP2',
                number:"青铜会员",
                xmember:"颐安中台",
                lmember:"0成长值",
                labellv:"虚拟权益名称",
                names:"国庆特惠券等3张国庆特惠券等3张券…",
                names2:"100",
                color:"#B2B2B2"
                },{
                name: 'VIP3',
                number:"白银会员",
                xmember:"小橘帮帮s",
                lmember:"200成长值且200积分",
                labellv:"虚拟权益名称",
                names:"国庆特惠券等3张国庆特惠券等3张券…",
                names2:"100",
                color:"#E96C50"
                },{
                name: 'VIP4',
                number:"黄金会员",
                xmember:"小橘帮帮",
                lmember:"200成长值且200积分",
                labellv:"虚拟权益名称",
                names:"国庆特惠券等3张国庆特惠券等3张券…",
                names2:"100",
                 color:"#75B06D"
                },{
                name: 'VIP5',
                number:"铂金会员",
                xmember:"小橘帮帮",
                lmember:"200成长值且200积分",
                labellv:"虚拟权益名称",
                names:"国庆特惠券等3张国庆特惠券等3张券…",
                names2:"100",
                 color:"#3A976A"
                },{
                name: 'VIP6',
                number:"钻石会员",
                xmember:"小橘帮帮",
                lmember:"0成长值",
                labellv:"虚拟权益名称",
                names:"国庆特惠券等3张国庆特惠券等3张券…",
                names2:"100",
                 color:"#81D4FF"
            },],
            input1:"",
            input2:"",
            input3:"",
            input4:"",
            input5:"",
            input6:"",
            input7:"",
            input8:"",
            memberType:"1",
            checkVal:"",
            tableData: [{
                id:1,
                date: '小橘帮帮',
                name: '5',
                address: false
            }, {
                id:2,
                date: '颐安中台',
                name: '5',
                address: true
            },],
            total:40,
            options: [{
            value: '选项1',
            label: '颐安中台'
            }, {
            value: '选项2',
            label: '小橘帮帮'
            }],
            value: ''
        }
    },
    methods:{
        cellStyles({ row, column, rowIndex, columnIndex }) {
            console.log(rowIndex,columnIndex,11111);
            if (columnIndex==1) {
                return `background:#EEEEEE;font-size:12px;textAlign:left`;
            } else {
                return "background:#EEEEEE;textAlign: center;fontSize:12px"
            }
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            console.log(rowIndex,columnIndex,11111);
            if (columnIndex==1) {
                return `font-size:12px;textAlign:left`;
            } else {
                return 'textAlign:center'
            }
        },
        newLeve(){
            this.$router.push({name:"newMemberLevel"})
        },
        chageS(item){
            console.log(item)
            this.checkVal=item.id;
        },
        handleSelectionChange(val) {
        if(val.length >=2){
            // 删除索引为0的
            // console.log(val.splice(0,val.length-1),'被删除的')
            let arrays = val.splice(0,val.length-1)
            arrays.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row); //除了当前点击的，其他的全部取消选中
            })
        }
        // console.log(val,'最后得到的')this.array = val
        },
        goRecord(){
            this.$router.push({name:"changeRecord",query:{}})
        }
    }
}
</script>
<style lang="less" scoped>
    .memberLevel{
        .ewm{
            position: relative;
            img{
                width:280px;
                height:460px;
            }
            .e{
                position: absolute;
                bottom: 149px;
                left: 83px;
                width:116px;
                height:116px;
            }
        }
        .f1{
            margin-bottom:15px;
            padding:30px 15px;
            border-radius: 6px;
            background: #fff;
            .t{
                font-size: 12px;
                font-weight: 400;
                color: #777777;
                img{
                    width:16px;
                    vertical-align: middle;
                }
                span{
                    color:#327EFF;
                }
                b{
                    padding:0 10px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #333940;
                }
                .el-button{
                    margin-left:10px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #327EFF;
                }
            }
            .ft{
                margin:15px 0;
                font-size: 12px;
                font-weight: 400;
                color: #777777;
            }
            div{
                display: flex;
                justify-content: space-between;
                p{
                    display: flex;
                    align-items: center;
                    .lb{
                        font-size: 14px;
                        font-weight: 400;
                        color: #676D73;
                    }
                    /deep/ .el-input .el-input__inner{
                        border-radius: 30px;
                        background: #F6F6F6;
                    }
                }
            }
        }
        .level{
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                margin-left:10px;
                 display: inline-block;
                width: 54px;
                height: 32px;
                background: #FEBD5F;
            }   
           
        }
        .zhuangt{
            margin-top:15px;
            padding-left:15px;
            height:38px;
            line-height: 38px;
            background: rgba(73, 116, 251, 0.11);
            border-radius: 4px;
            i{
                font-size:16px;
            }
            span{
                 font-weight: 500;
            }
            font-size: 14px;
            font-weight: 400;
            color: #258EF7;
        }
        .dialogContent2{
            display: flex;
            justify-content: space-between;
            padding:30px;
            .title{
                margin-bottom:20px;
                font-size: 16px;
                font-weight: 500;
                color: rgba(37, 45, 62, 0.85);
            }
            .border{
                margin-top:40px;
                width: 1px;
                height: 153px;
                background:#E6E6E6;
            }
            p{
                display: flex;
                align-items: center;
                margin-bottom:15px;
                i{
                    margin-right:10px;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #3373FE;
                    border-radius: 5px;
                }
                /deep/.el-input {
                    width:60px;
                    margin:0 10px;
                }
                /deep/ .el-input__inner{
                    border-radius: 30px;
                    background: #F6F6F6;
                    border:0px;
                }
            }
        }
        .dialogContent{
            padding-bottom:60px;
            .d1{
                padding:30px;
                p{
                    margin-bottom:10px;
                   font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    &:last-of-type{
                        margin:0;
                    }
                }
            }
        }
        .haibao{
            padding:30px;
            display: flex;
            // justify-content: space-between;
            img{
                width:280px;
                
            }
            .shada{
                margin-left:30px;
                img{
                    &:first-of-type{
                        margin-left:6px;
                    }
                    margin-right:6px;
                    width:22px;
                    vertical-align: middle;
                    // height:22px;
                }
                p{
                    margin-bottom:20px;
                    &:first-of-type{
                        font-size: 14px;
                        font-weight: 500;
                        color: #333333;
                    }
                    &:nth-child(2){
                        display: flex;
                        width:300px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #258EF7;
                        border: 1px solid #D8D8D8;
                        border-radius: 16px;
                        span{
                            display: inline-block;
                            padding:5px 15px;
                            &:first-of-type{
                                width:180px;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                white-space: nowrap;
                                border-right:1px solid #ccc;
                            }
                        }
                    }
                    &:nth-child(3){
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                    }
                    &:last-of-type{
                        .el-button{
                            border: 1px solid #3373FE;
                            font-size: 12px;
                            font-weight: 400;
                            color: #3373FE;
                        }
                        .dow.el-button{
                            background: #3373FE;
                            color: #FFFFFF;
                        }   
                    }
                }
            }
        }
        .dialog-footer{
            display: block;
            .el-button{
                border-radius: 30px;
            }
        }
        /deep/ .el-checkbox__inner{
            border-radius: 10px;
        }
        /deep/.el-dialog__footer{
            margin-top:30px;
            border-top:1px solid #FFF0F0F0;
        }
    }
</style>